module.exports = [{"type":"title","text":"2025-09-01"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"USDT-M Perp Futures:Added Trading Rules API"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog/2025-09-01.json
// module id = JH82
// module chunks = 3